export const formatDate = (dateString) => {
  if (!dateString) return null

  const date = new Date(dateString)

  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')

  return `${year}-${month}-${day}`
}

export const formatDateLocale = (dateString, time = true) => {
  if (!dateString) {
    return
  }

  const date = new Date(dateString);
  const validDate = !isNaN(date.getTime());

  if (!validDate) {
    return dateString;
  }

  if (time) {
    return date.toLocaleDateString('it-IT', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    })
  } else {
    return date.toLocaleDateString('it-IT', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    })
  }
}
